import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

const metaOverrideSet = buildFacetDesignOverride()
  // Institution can't be changed, and per the design, should not be shown
  .nameOverride(['institution'], { hidden: true })
  // It's weird to just see "Account / Liability Type", and during the add step we call it "Category". At the same time, I don't want to touch the existing account resource since it's used in other places and delicate
  .nameOverride('type', { prompt: 'Category' })
// Allow Account Owner Notes to be shown, it's being hidden because it's not in go/consts/accountType.go PersonalRetirementAccountAttributes etc under the account resource
  .nameOverride('owner', { hidden: false });

export default metaOverrideSet;
